import React, { FC, useState } from 'react';
import Styles from '@/assets/js/Styles';
import { PageStatusCircle } from '@/components/PageStatusCircle';
import { useControlledFieldArray } from '../../../hooks/useControlledFieldArray';
import { BlockPath } from '../../../editor/PageEditor/CurrentBlockProvider';
import { BlockSpecificPage } from '../../../editor/lib/declarations/BlockSpecificPage';
import { HeaderMenuBlock } from '../../../declarations/models/blocks/settingsBlocks/HeaderMenuBlock';
import LinkListItem from '../../../components/Links/LinkListItem';
import { LinkType } from '../../../declarations/models/LinkType';
import { Draggable } from '../../../declarations/Draggable';
import Links from '../../../components/Links/Links';

export interface LanguageMenuFocusMenuSettings {
  blockPath: BlockPath;
}

export const LanguageMenuFocusMenuSettings: FC<LanguageMenuFocusMenuSettings> = ({ blockPath }) => {
  const [itemVisible, setItemVisible] = useState<boolean>(true);
  const {
    fields: focusItems,
    append,
    update,
    move,
    remove,
  } = useControlledFieldArray<BlockSpecificPage<HeaderMenuBlock>, `${BlockPath}.focusitems`>({
    name: `${blockPath}.focusitems`,
  });

  const handleMove = (fromIndex: number, toIndex: number) => {
    // Its critical that settings are hidden during move to prevent rendering issues!!!!!!!!!!!!!!!!!!!!!!!!!!
    setItemVisible(false);
    move(fromIndex, toIndex);
    setTimeout(() => {
      // Re-show settings after move is done
      setItemVisible(true);
    }, 0);
  };

  const handleRemove = (index: number) => {
    setItemVisible(false);
    remove(index);
    setTimeout(() => {
      // Re-show settings after move is done
      setItemVisible(true);
    }, 0);
  };

  return (
    <>
      {itemVisible &&
        focusItems?.map((item, i) => (
          <LinkListItem
            key={`${item.id}`}
            linkType={item.type as LinkType}
            type={Draggable.OTHER}
            index={i}
            onReorder={handleMove}
            onDelete={handleRemove}
            itemsArrayName='focusitems'
            showLinkDescriptionField={false}
            showCSSclassField
            onChangeFile={() => null}
            blockPath={blockPath}
            iconOverride={'status' in item ? <PageStatusCircle status={item.status} size={20} /> : undefined}
            color={Styles.Colors.LIGHT_GREY}
          />
        ))}
      <Links
        onUpdate={update}
        onAppend={append}
        onRemove={handleRemove}
        onReorder={handleMove}
        showLinkItems={false}
        showLinkDescriptionField={false}
        showLinkStyleSelector={false}
        showListChildrenInput={false}
        linkItems={focusItems}
        linkTypes={[LinkType.PAGE, LinkType.LINK]}
        blockPath={blockPath}
      />
    </>
  );
};

export default LanguageMenuFocusMenuSettings;
